<template>
	<div>
	  <el-row :gutter="20" class="mb-20">
	    <el-col :xs="24" :sm="24" :lg="24">
	      <el-card class="box-card">
	        <el-form label-position="top"
	            :model="form"
	             :rules="rules"
	             ref="dataForm"
	             label-width="100px">

	          <el-row>
	          	<el-col :xs="24" :sm="24" :md="24" :lg="4" class="pr-10">
	              <el-form-item label="課程編號" prop="courseCode">
	                <el-input v-model="form.courseCode" autocomplete="off"></el-input>
	              </el-form-item>
	            </el-col>
	          	<el-col :xs="24" :sm="24" :md="24" :lg="10" class="pr-10">
	              <el-form-item label="課程名稱" prop="name">
	                <el-input v-model="form.name" autocomplete="off"></el-input>
	              </el-form-item>
	            </el-col>
	          	<el-col :xs="24" :sm="24" :md="24" :lg="5" class="pr-10">
	              <el-form-item label="課程分類" prop="catId">
	                <el-select v-model="form.catId" placeholder="選擇課程分類">
		                <el-option v-for="cat in categories"
		                           :key="cat.id"
		                           :label="cat.catName"
		                           :value="cat.id"></el-option>
		              </el-select>
	              </el-form-item>
	            </el-col>
	            <el-col :xs="24" :sm="24" :md="24" :lg="5" class="pr-10">
	              <el-form-item label="課程時數" prop="courseHours">
	                <el-input type="number" :min="1" v-model.number="form.courseHours"></el-input>
	              </el-form-item>
	            </el-col>
	          </el-row>

	          <el-row>
	          	<el-col :xs="24" :sm="24" :md="24" :lg="10" class="pr-10">
	              <el-form-item label="課程簡介" prop="courseDesc">
	                <el-input type="textarea" :rows="3" placeholder="課程簡介..." v-model="form.courseDesc">
              		</el-input>
	              </el-form-item>
	            </el-col>
	          	<el-col :xs="24" :sm="24" :md="24" :lg="6">
	              <el-form-item label="課程開始日" prop="courseDateStart">
	              	<el-date-picker
		                v-model="form.courseDateStart"
		                type="date"
		                format="yyyy/MM/dd"
		                value-format="yyyy/MM/dd"
		                placeholder="課程開始日">
		              </el-date-picker>
		            </el-form-item>
		          </el-col>
		          <el-col :xs="24" :sm="24" :md="24" :lg="6">
		            <el-form-item label="課程結束日" prop="courseDateEnd">
		              <el-date-picker
		                v-model="form.courseDateEnd"
		                type="date"
		                format="yyyy/MM/dd"
		                value-format="yyyy/MM/dd"
		                placeholder="課程結束日">
		              </el-date-picker>
		            </el-form-item>
	            </el-col>

	          </el-row>


	          


	          <div class="text-right">
	            <el-button type="primary" @click="saveData('dataForm')">儲存資料</el-button>
	        	</div>

	        </el-form>
	      </el-card>
	    </el-col>
	  </el-row>
	 </div>
</template>

<script>

import {mapState} from 'vuex'
export default {
	name: 'CourseBasicInfo',
	components:{

	},
	computed: {
    ...mapState('login', ['userInfo']),
  },
	data(){
		let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
		return {
			courseId:'',
			form:{
				courseCode:'',
				name:'',
				catId:1,
				courseDesc:'',
				courseHours:0,
				courseDateStart:'',
				courseDateEnd:''
			},
			rules:{
				name: [{validator: checkName, trigger: 'change'}],
				courseCode: [{validator: checkName, trigger: 'change'}]
			},
			categories:[]
		}
	},
	methods:{
		saveData(formName){
			this.$refs[formName].validate( valid => {
        if (valid) {
        	
          this.request.post("/course", this.form).then(res => {
            if (res.code === '200') {
              // this.loadData()
              this.showResult('success', this.$t('action.save_success'))
            } else {
              this.showResult('error', this.$t('action.save_error', {err: res.message}))
            }
          })
        }
      })
		},
		loadCategory() {
	    if (this.categories.length === 0) {
	      let query = {
	        pageNum: 1,
	        pageSize: 9999,
	        queryField: '',
	        keyword: '',
	        owner: this.userInfo.id
	      }
	      this.request.get("/course/category", {params: query} ).then(res => {
	        if (res.code === '200') {
	          this.categories = res.data.records
	        } else {
	          this.showResult('error', '無法取得課程分類資料')
	        }
	      })
	    }
		},
		loadData(){
			this.request.get("/course/"+this.courseId).then(res => {
        if (res.code === '200') {
          this.form = res.data
          
        } else {
          this.showResult('error', '無法取得課程資料')
        }
      })
		}
	},
	mounted(){
		this.courseId = parseInt(this.$route.params.cid)
		this.loadCategory()
		this.loadData()
	}
}

</script>

<style scoped>
.box-card >>> .el-form--label-top .el-form-item__label {
	padding: 0;
}

.txt {
  color: red;
  font-size: 15px;
}
.cert-no{
  position: absolute;
  top: 105px;
  left: 610px;
}
.eng-name {
  position: absolute;
  top: 250px;
  left: 370px;
}
.cht-name {
  position: absolute;
  top: 290px;
  left: 160px;
}


</style>


